import { render } from "./LoaderOval.vue?vue&type=template&id=4b5109b1&scoped=true"
import script from "./LoaderOval.vue?vue&type=script&lang=js"
export * from "./LoaderOval.vue?vue&type=script&lang=js"

import "./LoaderOval.vue?vue&type=style&index=0&id=4b5109b1&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5109b1"]])

export default __exports__